import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-internal-assessment-config',
  templateUrl: './internal-assessment-config.component.html',
  styleUrls: ['./internal-assessment-config.component.scss']
})
export class InternalAssessmentConfigComponent implements OnInit {

  @Input() subjectId: any = 0;
  @Input() subjectName: string = '';
  @Output() configSaved = new EventEmitter<any>();

  constructor(private dataService: DataService) { }

  loading: boolean = false;
  components: any[] = [];
  
  componentTypes = [
    { value: 'theory', label: 'Theory' },
    { value: 'practical', label: 'Practical' },
    { value: 'viva', label: 'Viva' },
    { value: 'seminar', label: 'Seminar' },
    { value: 'case_presentation', label: 'Case Presentation' },
    { value: 'record', label: 'Record' },
    { value: 'attendance', label: 'Attendance' },
    { value: 'file', label: 'File/Assignment' },
    { value: 'other', label: 'Other' }
  ];

  newComponent: any = this.getEmptyComponent();
  editingIndex: number = -1;

  ngOnInit(): void {
    this.loadConfiguration();
  }

  getEmptyComponent() {
    return {
      component_type: 'theory',
      component_name: '',
      base_marks: 50,
      scaled_marks: 25,
      number_of_attempts: 2,
      best_of_attempts: 2,
      is_auto_calculated: 1,
      display_order: 0
    };
  }

  loadConfiguration() {
    this.loading = true;
    this.dataService.getIAConfig(this.subjectId).subscribe((res: any) => {
      this.loading = false;
      if (res.status == 0) {
        this.components = res.data;
      }
    });
  }

  addComponent() {
    if (!this.newComponent.component_name) {
      alert('Please enter component name');
      return;
    }

    const data = {
      ...this.newComponent,
      subject_id: this.subjectId
    };

    this.dataService.saveIAConfig(data).subscribe((res: any) => {
      if (res.status == 0) {
        this.loadConfiguration();
        this.newComponent = this.getEmptyComponent();
        alert('Component added successfully');
      } else {
        alert(res.msg);
      }
    });
  }

  editComponent(index: number) {
    this.editingIndex = index;
    this.newComponent = { ...this.components[index] };
  }

  updateComponent() {
    if (this.editingIndex < 0) return;

    this.dataService.updateIAConfig(this.newComponent).subscribe((res: any) => {
      if (res.status == 0) {
        this.loadConfiguration();
        this.cancelEdit();
        alert('Component updated successfully');
      } else {
        alert(res.msg);
      }
    });
  }

  deleteComponent(id: number) {
    if (!confirm('Are you sure you want to delete this component? This may affect existing scores.')) {
      return;
    }

    this.dataService.deleteIAConfig(id).subscribe((res: any) => {
      if (res.status == 0) {
        this.loadConfiguration();
        alert('Component deleted successfully');
      } else {
        alert(res.msg);
      }
    });
  }

  cancelEdit() {
    this.editingIndex = -1;
    this.newComponent = this.getEmptyComponent();
  }

  closeModal() {
    //@ts-ignore
    $('#modal-ia-config').modal('hide');
    this.configSaved.emit();
  }

}
